
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/4cd80efa9d34f8aa17fd1397e18dc09c.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white w-full">
        <img 
          src="https://readdy.ai/api/search-image?query=Premium%20luxury%20barbershop%20logo%20design%20featuring%20elegant%20golden%20amber%20professional%20straight%20razor%20blade%20crossed%20with%20classic%20black%20barber%20comb%20in%20sophisticated%20X%20formation%20on%20solid%20black%20background%20with%20refined%20metallic%20finish%20representing%20Black%20excellence%20in%20grooming%20with%20modern%20minimalist%20aesthetic%20and%20high%20end%20appeal&width=200&height=200&seq=nappyrootz-razor-comb-logo-004&orientation=squarish" 
          alt="Nappy Rootz Logo" 
          className="h-32 w-auto mx-auto mb-8"
        />
        <h1 className="text-5xl md:text-7xl font-black mb-6 leading-tight tracking-tight">
          ROOTED IN CULTURE.<br />SHARP IN STYLE
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-stone-300 max-w-3xl mx-auto font-light">
          At Nappy Rootz, we specialize in precision grooming rooted in tradition, style, and respect for the culture. From classic cuts to modern fades — every crown matters.
        </p>
        
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <button 
            onClick={() => scrollToSection('book')}
            className="bg-gradient-to-r from-amber-600 to-amber-500 text-black px-8 py-4 rounded-full text-base font-bold hover:from-amber-500 hover:to-amber-400 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-amber-500/20"
          >
            BOOK YOUR CUT →
          </button>
          <button 
            onClick={() => scrollToSection('services')}
            className="border border-stone-400 text-stone-200 px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-black hover:border-white transition-all whitespace-nowrap cursor-pointer"
          >
            VIEW SERVICES
          </button>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-stone-400">
          <div className="flex items-center gap-2">
            <i className="ri-phone-line text-amber-500"></i>
            <a href="tel:+18644499072" className="hover:text-amber-500 transition-colors">864.449.9072</a>
          </div>
          <span className="text-stone-600">•</span>
          <div className="flex items-center gap-2">
            <i className="ri-map-pin-line text-lg text-amber-500"></i>
            <span>50 Parkins Mill Road, Greenville, SC</span>
          </div>
          <span className="text-stone-600">•</span>
          <div className="flex items-center gap-3">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center border border-stone-600 rounded-full hover:bg-amber-500 hover:border-amber-500 hover:text-black transition-all cursor-pointer">
              <i className="ri-instagram-line"></i>
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center border border-stone-600 rounded-full hover:bg-amber-500 hover:border-amber-500 hover:text-black transition-all cursor-pointer">
              <i className="ri-facebook-line"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center border border-stone-600 rounded-full hover:bg-amber-500 hover:border-amber-500 hover:text-black transition-all cursor-pointer">
              <i className="ri-twitter-x-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button onClick={() => scrollToSection('services')} className="cursor-pointer">
          <i className="ri-arrow-down-line text-amber-500 text-3xl"></i>
        </button>
      </div>
    </section>
  );
}
